enum PredictiveAnalyticsType {
    simple = 0,
    interaction = 1
}

export default PredictiveAnalyticsType;
